// Sportpacks Redesign - (c) 2026 NextPercent, nextpercent.de
// Lizenziert ausschliesslich fuer sport-packs.myshopify.com.
// Einsatz in weiteren Shops nur mit schriftlicher Genehmigung: info@nextpercent.de
(() => {
  const cache = new Map();
  const root = window.Shopify?.routes?.root || '/';
  const strings = window.spShoppingStrings || {complete_fit:'Passend zu deinem Fit',size:'Größe wählen',add:'Hinzufügen',adding:'Wird hinzugefügt …',error:'Das hat gerade nicht geklappt. Bitte versuche es erneut.'};
  const get = url => {
    if (!cache.has(url)) cache.set(url, fetch(url,{signal:AbortSignal.timeout(10000)}).then(r => {if (!r.ok) throw new Error('Request failed');return r.json();}).catch(e=>{cache.delete(url);throw e;}));
    return cache.get(url);
  };
  const category = title => /trackpants|jogger|sweatpants|shorts|jeans|hose/i.test(title) ? 'bottom' : /hoodie|shirt|polo|pullover|jacket|jacke|sweater|crewneck|zip|jumper|cardigan|windbreaker|strick/i.test(title) ? 'top' : 'other';
  const original = title => /sportz|sportpacks basic/i.test(title);
  const parts = title => title.split(/\s*\|\s*/);
  const cleanTitle = title => {
    let text=parts(title.replace(/\*/g,''))[0].replace(/\s+/g,' ').trim();
    if(text===text.toUpperCase())text=text.toLowerCase().replace(/\b[a-z]/g,c=>c.toUpperCase());
    return text.replace(/PREMIUM/g,'Premium');
  };
  const price = (cents,currency) => new Intl.NumberFormat(currency === 'EUR' ? 'de-DE' : document.documentElement.lang,{style:'currency',currency}).format(cents / 100);
  const el = (tag,cls,text) => {const n=document.createElement(tag);if(cls)n.className=cls;if(text)n.textContent=text;return n;};
  class CrossSell extends HTMLElement {
    connectedCallback() {
      this.alive=true;
      this.load();
    }
    disconnectedCallback() { this.alive=false; }
    async load() {
      try {
        const id=this.dataset.productId;
        const limit=Math.max(1,Math.min(10,Number(this.dataset.limit)||3));
        const source=this.dataset.source || 'legacy';
        const handles=(this.dataset.handles||'').split(',').filter(Boolean);
        const eligible=p=>p?.available && String(p.id)!==id && !(this.dataset.exclude||'').split(',').includes(String(p.id));
        if(source!=='legacy'){
          let selected=[];
          if(handles.length) selected=(await Promise.all(handles.slice(0,10).map(h=>get(`${root}products/${encodeURIComponent(h)}.js`).catch(()=>null)))).filter(eligible);
          else if(source!=='manual'){
            const intent=source==='related'?'related':'complementary';
            const response=await get(`${root}recommendations/products.json?product_id=${id}&limit=10&intent=${intent}`).catch(()=>({products:[]}));
            selected=(await Promise.all((response.products||[]).map(p=>get(`${root}products/${encodeURIComponent(p.handle)}.js`).catch(()=>null)))).filter(eligible);
          }
          if(!this.alive)return;
          if(selected.length){this.show(selected.slice(0,limit));return;}
          if(handles.length || source==='manual' || this.dataset.fallback!=='true'){this.show([]);return;}
        }
        const excluded=new Set((this.dataset.exclude || '').split(',').concat(id));
        const sourceTitle=this.dataset.title;
        const sourceCategory=category(sourceTitle);
        const isOriginal=original(sourceTitle);
        const sourceSize=parts(sourceTitle)[1]?.trim();
        const related=await get(`${root}recommendations/products.json?product_id=${id}&limit=10&intent=related`).catch(()=>({products:[]}));
        let candidates=related.products || [];
        const suitable=p=>!excluded.has(String(p.id)) && !/mystery|tracksuit/i.test(p.title) && original(p.title)===isOriginal && category(p.title)!=='other' && (sourceCategory==='other' || category(p.title)!==sourceCategory) && (isOriginal || !sourceSize || !p.title.includes('|') || parts(p.title)[1].trim().split('/').includes(sourceSize));
        if(isOriginal || candidates.filter(suitable).length<3){
          const extra=await get(`${root}collections/${isOriginal?'sportz':'alle-artikel-1'}/products.json?limit=50`);
          candidates=candidates.concat(extra.products || []);
        }
        const seen=new Set();
        candidates=candidates.filter(p=>{if(seen.has(p.id)||!suitable(p))return false;seen.add(p.id);return true;});
        const sourceColor=/black|schwarz/i.test(sourceTitle)?/black|schwarz/i:/grey|gray|grau/i.test(sourceTitle)?/grey|gray|grau/i:null;
        const setScore=p=>(sourceColor?.test(p.title)?4:0)+(isOriginal && (sourceCategory==='bottom'?/original hoodie/i.test(p.title):/baggy jogger/i.test(p.title))?2:0);
        candidates.sort((a,b)=>setScore(b)-setScore(a));
        const ready=[];
        for(let offset=0;offset<Math.min(candidates.length,20)&&ready.length<limit;offset+=3){
          if(!this.alive)return;
          const batch=await Promise.all(candidates.slice(offset,Math.min(offset+3,20)).map(candidate=>get(`${root}products/${encodeURIComponent(candidate.handle)}.js`).catch(()=>null)));
          for(const p of batch)if(p?.available && p.variants.some(v=>v.available)&&ready.length<limit)ready.push(p);
        }
        if(!this.alive)return;
        this.show(ready);
      } catch { /* Recommendations are optional; the purchase flow remains available. */ }
    }
    show(products) {
      this.querySelector('.sp-cross-sell__items').replaceChildren(...products.map(p=>this.card(p)));
      const empty=this.querySelector('[data-empty]');
      if(empty)empty.hidden=products.length>0;
      this.hidden=!products.length && !this.hasAttribute('data-editor');
    }
    card(p) {
      const card=el('article','sp-cross-card');
      const link=el('a','sp-cross-card__image');link.href=root+'products/'+p.handle;
      const img=el('img');img.src=p.featured_image;img.alt=cleanTitle(p.title);img.width=90;img.height=120;img.loading='lazy';link.append(img);
      const info=el('div','sp-cross-card__info');const title=el('a','sp-cross-card__title',cleanTitle(p.title));title.href=link.href;
      const amount=el('span','sp-cross-card__price',price(p.price,this.dataset.currency));info.append(title,amount);
      const form=el('form','sp-cross-card__form');
      const available=p.variants.filter(v=>v.available);
      const color=original(p.title)?parts(p.title)[1]:'';
      if(!this.hasAttribute('data-drawer')){
        const onlyDefault=p.has_only_default_variant || (p.variants.length===1 && p.variants[0].title==='Default Title');
        const detail=color || (onlyDefault?'':parts(p.title)[1]);
        if(detail)info.append(el('span','sp-cross-card__size',detail));
        const media=el('div','sp-cross-card__media');
        const quick=el('sp-inline-quick-add');quick.hidden=true;
        if(p.variants.length===1 && !p.requires_selling_plan)quick.setAttribute('data-single-variant','');
        const toggle=el('button','sp-inline-quick__toggle');toggle.type='button';
        toggle.setAttribute('aria-expanded','false');toggle.setAttribute('aria-label',strings.size+' · '+cleanTitle(p.title));
        const icon=el('span');icon.setAttribute('aria-hidden','true');toggle.append(icon);
        const panel=el('div','sp-inline-quick__panel');panel.inert=true;
        const clip=el('div','sp-inline-quick__clip');
        const options=el('div','sp-inline-quick__options');options.setAttribute('role','group');options.setAttribute('aria-label',strings.size);
        if(p.requires_selling_plan){
          const details=el('a','',cleanTitle(p.title));details.href=link.href;options.append(details);
        }else{
          p.variants.forEach(v=>{
            const label=onlyDefault?strings.add:v.title;
            const choice=el('button','',label);choice.type='button';choice.dataset.variant=String(v.id);
            choice.dataset.quantity=String(v.quantity_rule?.min || 1);choice.disabled=!v.available;
            choice.setAttribute('aria-label',label+(v.available?'':' – '+(strings.soldOut || 'Sold out')));
            if(p.price_varies)choice.append(el('small','',price(v.price,this.dataset.currency)));
            options.append(choice);
          });
        }
        const status=el('p','sp-inline-quick__status');status.setAttribute('role','status');status.setAttribute('aria-live','polite');
        clip.append(options,status);panel.append(clip);quick.append(toggle,panel);media.append(link,quick);
        card.append(media,info);return card;
      }
      if(color && available.length>1)info.append(el('span','sp-cross-card__size',color));
      let select;
      if(!p.has_only_default_variant && available.length>1){
        select=el('select');select.hidden=true;select.setAttribute('aria-label',strings.size+' · '+cleanTitle(p.title));
        const initial=el('option','',strings.size);initial.value='';initial.disabled=true;initial.selected=true;select.append(initial);
        available.forEach(v=>{const option=el('option','',v.title);option.value=v.id;select.append(option);});
        select.addEventListener('change',()=>{const v=available.find(v=>String(v.id)===select.value);amount.textContent=price(v.price,this.dataset.currency);});form.append(select);
        const picker=el('div','sp-size-picker');
        const summary=el('button','sp-size-picker__trigger',strings.size);summary.type='button';summary.setAttribute('aria-label',strings.size+' · '+cleanTitle(p.title));
        const panel=el('div','sp-size-picker__panel');
        const choices=el('div','sp-size-picker__choices');panel.append(choices);
        panel.id='sp-sizes-'+p.id+'-'+Math.random().toString(36).slice(2,8);
        summary.setAttribute('aria-controls',panel.id);
        picker.setOpen=open=>{picker.classList.toggle('is-open',open);summary.setAttribute('aria-expanded',String(open));panel.inert=!open;panel.setAttribute('aria-hidden',String(!open));};
        picker.setOpen(false);summary.addEventListener('click',()=>picker.setOpen(summary.getAttribute('aria-expanded')!=='true'));
        available.forEach(v=>{const choice=el('button','',v.title);choice.type='button';choice.setAttribute('aria-pressed','false');choice.addEventListener('click',()=>{select.value=String(v.id);summary.textContent=v.title;amount.textContent=price(v.price,this.dataset.currency);choices.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b===choice)));picker.setOpen(false);summary.focus();});choices.append(choice);});
        picker.addEventListener('keydown',e=>{if(e.key==='Escape'){e.stopPropagation();picker.setOpen(false);summary.focus();}});
        picker.addEventListener('focusout',e=>{if(!picker.contains(e.relatedTarget))picker.setOpen(false);});
        picker.append(summary,panel);form.append(picker);
      }else{
        const variantSize=available[0].title==='Default Title'?'':available[0].title;
        const size=original(p.title)?[color,variantSize].filter(Boolean).join(' · '):(parts(p.title)[1] || variantSize);
        if(size)info.append(el('span','sp-cross-card__size',size));
      }
      const button=el('button','sp-cross-card__add',strings.add+' +');button.type='submit';form.append(button);
      form.addEventListener('submit',async event=>{
        event.preventDefault(); if(button.disabled)return;
        if(select && !select.value){const picker=form.querySelector('.sp-size-picker');picker.setOpen(true);picker.querySelector('.sp-size-picker__trigger').focus();return;}
        button.disabled=true;button.textContent=strings.adding;
        const error=this.querySelector('.sp-cross-sell__error');error.textContent='';
        try{
          const drawer=document.querySelector('cart-drawer');
          const variant=select?select.value:available[0].id;
          const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(variant),quantity:1}],sections:['cart-drawer','cart-icon-bubble'],sections_url:location.pathname})});
          const result=await response.json();if(!response.ok)throw new Error(typeof result.description==='string'?result.description:strings.error);
          if(!result.sections?.['cart-drawer']){location.href=root+'cart';return;}
          if(drawer){drawer.setActiveElement(this.hasAttribute('data-drawer')?document.querySelector('#cart-icon-bubble'):button);drawer.renderContents(result);drawer.classList.remove('is-empty');}
          else location.href=root+'cart';
        }catch(e){error.textContent=e.message || strings.error;}
        finally{button.disabled=false;button.textContent=strings.add+' +';}
      });
      info.append(form);card.append(link,info);return card;
    }
  }
  if(!customElements.get('sp-cross-sell'))customElements.define('sp-cross-sell',CrossSell);
})();

// Keep Linkify's product grouping as the source, render accessible colour links.
(() => {
  const selector='linkify-product-colors-swatches';
  let queued=false;
  function renderColors(){
    queued=false;
    document.querySelectorAll('.sp-product '+selector).forEach(source=>{
      const swatches=[...source.querySelectorAll('linkify-product-colors-swatch')];
      if(!swatches.length)return;
      const signature=swatches.map(s=>[s.dataset.handle,s.getAttribute('aria-label'),s.hasAttribute('data-selected'),s.hasAttribute('data-soldout'),s.getAttribute('style')].join('|')).join(';');
      if(source.dataset.spSignature===signature && source.nextElementSibling?.classList.contains('sp-colors'))return;
      source.dataset.spSignature=signature;
      const wrapper=document.createElement('div');wrapper.className='sp-colors';
      const list=document.createElement('div');list.className='sp-colors__list';
      const selected=swatches.find(s=>s.hasAttribute('data-selected'));
      const colorName=s=>(s.getAttribute('aria-label')||'').split('|').pop().trim();
      const current=document.createElement('span');current.className='sp-colors__current';current.textContent=[window.spShoppingStrings?.color || source.parentElement.querySelector('label')?.textContent.trim(),selected?colorName(selected):''].filter(Boolean).join(' · ');
      const soldOut=window.spShoppingStrings?.soldOut || 'Sold out';
      for(const swatch of swatches){
        if(!swatch.dataset.handle)continue;
        const link=document.createElement('a');link.className='sp-color';
        link.href=(window.Shopify?.routes?.root||'/')+'products/'+encodeURIComponent(swatch.dataset.handle);
        const unavailable=swatch.hasAttribute('data-soldout');
        const name=colorName(swatch)+(unavailable?' · '+soldOut:'');
        link.setAttribute('aria-label',name);link.title=name;
        if(swatch.hasAttribute('data-selected'))link.setAttribute('aria-current','page');
        if(unavailable)link.classList.add('sp-color--sold');
        const chip=document.createElement('span');chip.className='sp-color__chip';chip.setAttribute('aria-hidden','true');
        chip.style.background=swatch.style.getPropertyValue('--color')||getComputedStyle(swatch).backgroundColor;
        const caption=document.createElement('span');caption.className='sp-color__tooltip';caption.textContent=name;
        link.append(chip,caption);link.addEventListener('click',event=>event.stopPropagation());list.append(link);
      }
      if(!list.children.length)return;
      wrapper.append(current,list);
      const previous=source.nextElementSibling;
      if(previous?.classList.contains('sp-colors'))previous.replaceWith(wrapper);else source.after(wrapper);
      source.classList.add('sp-colors-source');
      source.parentElement.classList.add('sp-colors-enhanced');
    });
  }
  const schedule=()=>{if(!queued){queued=true;requestAnimationFrame(renderColors);}};
  new MutationObserver(records=>{
    if(records.some(r=>(r.target instanceof Element && (r.target.matches(selector)||r.target.closest(selector))) || [...r.addedNodes].some(n=>n instanceof Element && (n.matches('webyze-linkify-product-colors,'+selector)||n.querySelector(selector)))))schedule();
  }).observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['data-selected','data-soldout','style']});
  renderColors();
})();
// Desktop rail pages vertically; mobile retains the native horizontal slider.
(() => {
 document.querySelectorAll('.sp-product .thumbnail-slider').forEach(slider=>{
  const rail=slider.querySelector('.thumbnail-list');
  const buttons=[...slider.querySelectorAll('.slider-button')];
  const update=()=>{if(!matchMedia('(min-width:750px)').matches)return;buttons.forEach(button=>{const atEnd=button.name==='previous'?rail.scrollTop<12:rail.scrollTop+rail.clientHeight>=rail.scrollHeight-2;button.disabled=atEnd;button.classList.toggle('sp-rail-unavailable',atEnd);});};
  buttons.forEach(button=>button.addEventListener('click',event=>{
   if(!matchMedia('(min-width:750px)').matches)return;
   event.preventDefault();event.stopImmediatePropagation();
   rail.scrollBy({top:(button.name==='previous'?-1:1)*Math.max(82,rail.clientHeight-82),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
  },true));
  rail.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(rail);update();
 });
})();

